export default
[
  {
    "name": "あいのやまの湯",
    "paths": [
      {
        "lat": 36.427963,
        "lng": 139.132173
      },
      {
        "lat": 36.427963,
        "lng": 139.126436
      },
      {
        "lat": 36.421494,
        "lng": 139.126436
      },
      {
        "lat": 36.421494,
        "lng": 139.132173
      }
    ]
  },
  {
    "name": "ヤオコー前橋関根",
    "paths": [
      {
        "lat": 36.433306,
        "lng": 139.05486
      },
      {
        "lat": 36.433306,
        "lng": 139.05276
      },
      {
        "lat": 36.431386,
        "lng": 139.05276
      },
      {
        "lat": 36.431386,
        "lng": 139.05486
      }
    ]
  },
  {
    "name": "上毛電気鉄道上泉駅",
    "paths": [
      {
        "lat": 36.394419,
        "lng": 139.107201
      },
      {
        "lat": 36.394419,
        "lng": 139.105276
      },
      {
        "lat": 36.394129,
        "lng": 139.105276
      },
      {
        "lat": 36.394129,
        "lng": 139.107201
      }
    ]
  },
  {
    "name": "北関東循環器病院",
    "paths": [
      {
        "lat": 36.456023,
        "lng": 139.049677
      },
      {
        "lat": 36.456023,
        "lng": 139.048154
      },
      {
        "lat": 36.454551,
        "lng": 139.048154
      },
      {
        "lat": 36.454551,
        "lng": 139.049677
      }
    ]
  },
  {
    "name": "富士見・芳賀エリア",
    "paths": [
      {
        "lat": 36.505543,
        "lng": 139.141832
      },
      {
        "lat": 36.5006289,
        "lng": 139.1419111
      },
      {
        "lat": 36.4888463,
        "lng": 139.1352238
      },
      {
        "lat": 36.4397734,
        "lng": 139.1283048
      },
      {
        "lat": 36.4386598,
        "lng": 139.1305282
      },
      {
        "lat": 36.4332706,
        "lng": 139.129335
      },
      {
        "lat": 36.4292774,
        "lng": 139.129487
      },
      {
        "lat": 36.4280678,
        "lng": 139.1295849
      },
      {
        "lat": 36.4280472,
        "lng": 139.1291277
      },
      {
        "lat": 36.4281648,
        "lng": 139.1288463
      },
      {
        "lat": 36.4281341,
        "lng": 139.1282904
      },
      {
        "lat": 36.428029,
        "lng": 139.1280523
      },
      {
        "lat": 36.427317,
        "lng": 139.1280145
      },
      {
        "lat": 36.4272282,
        "lng": 139.1281304
      },
      {
        "lat": 36.4271205,
        "lng": 139.1280561
      },
      {
        "lat": 36.4270945,
        "lng": 139.1278926
      },
      {
        "lat": 36.426951,
        "lng": 139.1278231
      },
      {
        "lat": 36.4269577,
        "lng": 139.1277522
      },
      {
        "lat": 36.4267249,
        "lng": 139.1276879
      },
      {
        "lat": 36.4266722,
        "lng": 139.127861
      },
      {
        "lat": 36.4265718,
        "lng": 139.1278132
      },
      {
        "lat": 36.4263964,
        "lng": 139.1277882
      },
      {
        "lat": 36.4264382,
        "lng": 139.1275975
      },
      {
        "lat": 36.4256955,
        "lng": 139.1272059
      },
      {
        "lat": 36.4252072,
        "lng": 139.1268917
      },
      {
        "lat": 36.4250349,
        "lng": 139.1267959
      },
      {
        "lat": 36.4250893,
        "lng": 139.1264544
      },
      {
        "lat": 36.4254487,
        "lng": 139.1261152
      },
      {
        "lat": 36.4248328,
        "lng": 139.1259222
      },
      {
        "lat": 36.4247426,
        "lng": 139.1258035
      },
      {
        "lat": 36.4246965,
        "lng": 139.1258659
      },
      {
        "lat": 36.4239512,
        "lng": 139.1256381
      },
      {
        "lat": 36.4233542,
        "lng": 139.1256922
      },
      {
        "lat": 36.4221009,
        "lng": 139.1254546
      },
      {
        "lat": 36.4202781,
        "lng": 139.1249693
      },
      {
        "lat": 36.4203523,
        "lng": 139.1246057
      },
      {
        "lat": 36.4200297,
        "lng": 139.1244847
      },
      {
        "lat": 36.4200946,
        "lng": 139.1241802
      },
      {
        "lat": 36.4200516,
        "lng": 139.1241688
      },
      {
        "lat": 36.4201243,
        "lng": 139.1236912
      },
      {
        "lat": 36.4200338,
        "lng": 139.1237098
      },
      {
        "lat": 36.4187924,
        "lng": 139.1233245
      },
      {
        "lat": 36.4186414,
        "lng": 139.1231813
      },
      {
        "lat": 36.4186755,
        "lng": 139.1229007
      },
      {
        "lat": 36.4184172,
        "lng": 139.1227791
      },
      {
        "lat": 36.418406,
        "lng": 139.1225019
      },
      {
        "lat": 36.4184292,
        "lng": 139.1223896
      },
      {
        "lat": 36.4182324,
        "lng": 139.122176
      },
      {
        "lat": 36.4182578,
        "lng": 139.122043
      },
      {
        "lat": 36.4177503,
        "lng": 139.1217083
      },
      {
        "lat": 36.4173319,
        "lng": 139.1209545
      },
      {
        "lat": 36.4173783,
        "lng": 139.1207475
      },
      {
        "lat": 36.4176455,
        "lng": 139.1207569
      },
      {
        "lat": 36.4177302,
        "lng": 139.1197766
      },
      {
        "lat": 36.4154963,
        "lng": 139.1198705
      },
      {
        "lat": 36.4149362,
        "lng": 139.1195869
      },
      {
        "lat": 36.4144241,
        "lng": 139.1186844
      },
      {
        "lat": 36.4142946,
        "lng": 139.1189659
      },
      {
        "lat": 36.4127601,
        "lng": 139.1175491
      },
      {
        "lat": 36.4062718,
        "lng": 139.1129664
      },
      {
        "lat": 36.4072669,
        "lng": 139.1099188
      },
      {
        "lat": 36.4062622,
        "lng": 139.1093971
      },
      {
        "lat": 36.4064313,
        "lng": 139.1077879
      },
      {
        "lat": 36.4053552,
        "lng": 139.1072964
      },
      {
        "lat": 36.4053881,
        "lng": 139.1068241
      },
      {
        "lat": 36.4045165,
        "lng": 139.1027024
      },
      {
        "lat": 36.4034828,
        "lng": 139.1013405
      },
      {
        "lat": 36.4007513,
        "lng": 139.0992128
      },
      {
        "lat": 36.4024733,
        "lng": 139.0961731
      },
      {
        "lat": 36.405082,
        "lng": 139.097072
      },
      {
        "lat": 36.405432,
        "lng": 139.095815
      },
      {
        "lat": 36.4066991,
        "lng": 139.0963635
      },
      {
        "lat": 36.4073982,
        "lng": 139.0956489
      },
      {
        "lat": 36.4066633,
        "lng": 139.0963491
      },
      {
        "lat": 36.4054439,
        "lng": 139.0958149
      },
      {
        "lat": 36.4066636,
        "lng": 139.0964081
      },
      {
        "lat": 36.4074217,
        "lng": 139.0956045
      },
      {
        "lat": 36.4074485,
        "lng": 139.0960762
      },
      {
        "lat": 36.409496,
        "lng": 139.095559
      },
      {
        "lat": 36.409735,
        "lng": 139.0946754
      },
      {
        "lat": 36.4101821,
        "lng": 139.0946874
      },
      {
        "lat": 36.4093154,
        "lng": 139.0941233
      },
      {
        "lat": 36.4106985,
        "lng": 139.094895
      },
      {
        "lat": 36.4115002,
        "lng": 139.094953
      },
      {
        "lat": 36.4113259,
        "lng": 139.0944973
      },
      {
        "lat": 36.4124122,
        "lng": 139.0943218
      },
      {
        "lat": 36.4130143,
        "lng": 139.0937497
      },
      {
        "lat": 36.4137983,
        "lng": 139.0932879
      },
      {
        "lat": 36.4139745,
        "lng": 139.0916379
      },
      {
        "lat": 36.4141505,
        "lng": 139.0902899
      },
      {
        "lat": 36.4158197,
        "lng": 139.0912476
      },
      {
        "lat": 36.4166799,
        "lng": 139.0915271
      },
      {
        "lat": 36.4195298,
        "lng": 139.0915959
      },
      {
        "lat": 36.4194488,
        "lng": 139.0919949
      },
      {
        "lat": 36.4246683,
        "lng": 139.0928191
      },
      {
        "lat": 36.4258736,
        "lng": 139.0895531
      },
      {
        "lat": 36.4248154,
        "lng": 139.0882289
      },
      {
        "lat": 36.4240913,
        "lng": 139.0868343
      },
      {
        "lat": 36.426143,
        "lng": 139.0812822
      },
      {
        "lat": 36.4276318,
        "lng": 139.0810465
      },
      {
        "lat": 36.4291756,
        "lng": 139.080726
      },
      {
        "lat": 36.4313183,
        "lng": 139.0795355
      },
      {
        "lat": 36.43511,
        "lng": 139.0758101
      },
      {
        "lat": 36.4350912,
        "lng": 139.0728593
      },
      {
        "lat": 36.4306017,
        "lng": 139.0699523
      },
      {
        "lat": 36.4311755,
        "lng": 139.0664794
      },
      {
        "lat": 36.4353573,
        "lng": 139.0586181
      },
      {
        "lat": 36.4402275,
        "lng": 139.0558399
      },
      {
        "lat": 36.4428224,
        "lng": 139.0515346
      },
      {
        "lat": 36.4455865,
        "lng": 139.054901
      },
      {
        "lat": 36.4546625,
        "lng": 139.0571717
      },
      {
        "lat": 36.4555408,
        "lng": 139.0547277
      },
      {
        "lat": 36.4548163,
        "lng": 139.0533329
      },
      {
        "lat": 36.454811,
        "lng": 139.0525212
      },
      {
        "lat": 36.4569497,
        "lng": 139.0513928
      },
      {
        "lat": 36.4571799,
        "lng": 139.050136
      },
      {
        "lat": 36.4691224,
        "lng": 139.0531896
      },
      {
        "lat": 36.4749639,
        "lng": 139.0622838
      },
      {
        "lat": 36.4838917,
        "lng": 139.069356
      },
      {
        "lat": 36.4977373,
        "lng": 139.0811811
      },
      {
        "lat": 36.5145522,
        "lng": 139.0993468
      }
    ]
  },
  {
    "name": "桂萱農協前バス停",
    "paths": [
      {
        "lat": 36.396913,
        "lng": 139.103583
      },
      {
        "lat": 36.396913,
        "lng": 139.102629
      },
      {
        "lat": 36.396407,
        "lng": 139.102629
      },
      {
        "lat": 36.396407,
        "lng": 139.103583
      }
    ]
  }
]
